<template lang="pug">
div
  v-alert(
    outlined
    type="info"
  ).
    На указанный Вами электронный адрес будет отправлено
    письмо с инструкцией для завершения процедуры изменения пароля
  api-form(
    v-model="data"
    v-bind="props"
    :method="save"
    :successCallback="successCallback"
  )
</template>
<script>
export default {
  data() {
    return {
      data: {},
      props: {
        'btn-props': {
          btnText: 'Отправить подтверждение',
        },
        fields: [
          {
            component: 'v-text-field',
            rules: 'required|email',
            text: 'Введите свой почтовый адрес',
            value: 'email',
            component_attrs: {
              rounded: true,
              outlined: true,
            },
          },
        ],
      },
    };
  },
  methods: {
    save({ data, obs }) {
      return this.$api.auth.sendResetPas(data, obs);
    },
    successCallback() {
      this.$modals.close();
      this.$toasted.success('Письмо отправлено');
    },
  },
};
</script>
